import { FilterKeys, Filters } from '../Types';

export const excludeByFilterKey = (key: FilterKeys) => {
  return (f: Filters) => f.filterKey !== key;
};

export const byFilterKey = (key: FilterKeys) => {
  return (f: Filters) => f.filterKey === key;
};
